import BigInfoIcon from 'designSystem/icons/Iconography/BigInfoIcon';
import ContentGuidelinesIcon from 'designSystem/icons/Iconography/ContentGuidelinesIcon';
import ErrorIcon from 'designSystem/icons/Iconography/ErrorIcon';
import SaveIcon from 'designSystem/icons/Iconography/SaveIcon';
import SuccessIcon from 'designSystem/icons/Iconography/SuccessIcon';
import { IconographyNameType, IconPropsType } from 'designSystem/types/icons';

const ICONOGRAPHY: Record<
  IconographyNameType,
  (props: IconPropsType) => JSX.Element
> = Object.freeze({
  save: SaveIcon,
  'content-guidelines': ContentGuidelinesIcon,
  'big-info-icon': BigInfoIcon,
  success: SuccessIcon,
  error: ErrorIcon,
});

export default ICONOGRAPHY;
